module.exports = __webpack_public_path__ + "images/emoji/fish.eac64c8794d1a9403cab.png";